import { useAddUserLog } from "core/hooks/useUserLog";
import { useNotifications } from "features/Notifications/useNotifications";
import { useCallback } from "react";

export function useLogDocumentView() {
  const addLog = useAddUserLog();
  const { markNotificationAsReadByItemId } = useNotifications();
  return useCallback(
    async (nodeId: string) => {
      await Promise.all([
        addLog("DmsDocNodeDocument", nodeId),
        markNotificationAsReadByItemId(nodeId),
      ]);
    },
    [addLog, markNotificationAsReadByItemId]
  );
}
